import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';

function HeaderOne() {
  useEffect(() => {
    const initMobileMenu = () => {
      if ($('.hidden-bar').length === 0) return;

      $(document)
        .off('.mobilemenu')
        // Open mobile menu
        .on('click.mobilemenu', '.hidden-bar-opener', function (e) {
          e.preventDefault();
          $('body, .hidden-bar').addClass('visible-sidebar');
        })
        // Close mobile menu
        .on('click.mobilemenu', '.hidden-bar-closer, .menu-backdrop', function () {
          $('body, .hidden-bar').removeClass('visible-sidebar');
        })
        // Close on ESC
        .on('keydown.mobilemenu', function (e) {
          if (e.keyCode === 27) {
            $('body, .hidden-bar').removeClass('visible-sidebar');
          }
        })
        // Dropdown toggle in mobile menu
        .on('click.mobilemenu', '.side-menu .dropdown > a', function (e) {
          e.preventDefault();
          const $this = $(this);
          const $submenu = $this.next('ul');
          const $icon = $this.find('i');

          $submenu.slideToggle(300);
          $icon.toggleClass('fa-angle-down fa-angle-right');

          // Close other open dropdowns
          $this.parent().siblings().find('ul').slideUp(300);
          $this.parent().siblings().find('i').removeClass('fa-angle-right').addClass('fa-angle-down');
        });
    };

    const timer = setTimeout(initMobileMenu, 150);
    window.addEventListener('resize', initMobileMenu);

    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', initMobileMenu);
      $(document).off('.mobilemenu');
    };
  }, []);

  // Close menu when any link is clicked (mobile UX)
  const closeMobileMenu = () => {
    $('body, .hidden-bar').removeClass('visible-sidebar');
  };

  return (
    <>
      {/* ====================== MAIN HEADER ====================== */}
      <header className="main-header header-down">
        <div className="header-top">
          <div className="auto-container">
            <div className="inner clearfix">
              <div className="top-left clearfix">
                <ul className="top-info clearfix">
                  <li><i className="icon far fa-map-marker-alt"></i> Restoria, Arrondissement, Paris 9578</li>
                  <li><i className="icon far fa-clock"></i> Daily : 8.00 am to 10.00 pm</li>
                </ul>
              </div>
              <div className="top-right clearfix">
                <ul className="top-info clearfix">
                  <li><a href="tel:+11234567890"><i className="icon far fa-phone"></i> +1 123 456 7890</a></li>
                  <li><a href="mailto:booking@restaurant.com"><i className="icon far fa-envelope"></i> booking@restaurant.com</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="header-upper">
          <div className="auto-container">
            <div className="main-box clearfix">
              {/* Logo */}
              <div className="logo-box">
                <div className="logo">
                  <Link to="/">
                    <img
                      src="assets/images/tickling-tummy-logo-coimbatore.svg"
                      alt="Tickling Tummy"
                      title="Tickling Tummy"
                    />
                  </Link>
                </div>
              </div>

              <div className="nav-box clearfix">
                {/* Desktop Menu */}
                <div className="nav-outer clearfix">
                  <nav className="main-menu">
                    <ul className="navigation clearfix">
                      <li><Link to="/">Home</Link></li>
                      <li><Link to="/about">About Us</Link></li>
                      <li className="dropdown">
                        <Link to="#">Services</Link>
                        <ul>
                          <li><Link to="/daily-meals">Daily Meals</Link></li>
                          <li><Link to="/catering">Catering</Link></li>
                          <li><Link to="/corporate">Corporate</Link></li>
                          <li><Link to="/food-delivery-in-train">Food Delivery in Train</Link></li>
                          <li><Link to="/meal-subscription">Meal Subscription</Link></li>
                          <li><Link to="/pre-order-meals">Pre Order Meals</Link></li>
                          <li><Link to="/gifting">Gifting</Link></li>
                        </ul>
                      </li>
                      <li><Link to="/blogs">Blogs</Link></li>
                      <li><Link to="/contact">Contact</Link></li>
                    </ul>
                  </nav>
                </div>

                {/* Order Now */}
                <div className="links-box clearfix">
                  <div className="link link-btn">
                    <a
                      href="https://api.whatsapp.com/send/?phone=919385000111&text=Hi, I want to place an order!&app_absent=0"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="theme-btn btn-style-one clearfix"
                    >
                      <span className="btn-wrap">
                        <span className="text-one">Order Now</span>
                        <span className="text-two">Order Now</span>
                      </span>
                    </a>
                  </div>
                </div>

                {/* Mobile Toggle */}
                <div className="nav-toggler">
                  <button className="hidden-bar-opener">
                    <span className="hamburger">
                      <span className="top-bun"></span>
                      <span className="meat"></span>
                      <span className="bottom-bun"></span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* ====================== MOBILE MENU (HIDDEN SIDEBAR) ====================== */}
      <div className="hidden-bar">
        <div className="hidden-bar-inner">
          {/* Logo + Close Button Row */}
          <div className="mobile-header-top">
            <div className="mobile-logo">
              <Link to="/" onClick={closeMobileMenu}>
                <img
                  src="assets/images/tickling-tummy-logo-coimbatore.svg"
                  alt="Tickling Tummy"
                  style={{ height: '50px' }}
                />
              </Link>
            </div>
            <button className="hidden-bar-closer">
              <span className="icon far fa-times"></span>
            </button>
          </div>

          {/* Mobile Navigation */}
          <div className="side-menu-wrapper">
            <nav className="side-menu">
              <ul>
                <li><Link to="/" onClick={closeMobileMenu}>Home</Link></li>
                <li><Link to="/about" onClick={closeMobileMenu}>About Us</Link></li>
                <li className="dropdown">
                  <a href="#">Services <i className="fa fa-angle-down"></i></a>
                  <ul>
                    <li><Link to="/daily-meals" onClick={closeMobileMenu}>Daily Meals</Link></li>
                    <li><Link to="/catering" onClick={closeMobileMenu}>Catering</Link></li>
                    <li><Link to="/corporate" onClick={closeMobileMenu}>Corporate</Link></li>
                    <li><Link to="/food-delivery-in-train" onClick={closeMobileMenu}>Food Delivery in Train</Link></li>
                    <li><Link to="/meal-subscription" onClick={closeMobileMenu}>Meal Subscription</Link></li>
                    <li><Link to="/pre-order-meals" onClick={closeMobileMenu}>Pre Order Meals</Link></li>
                    <li><Link to="/gifting" onClick={closeMobileMenu}>Gifting</Link></li>
                  </ul>
                </li>
                <li><Link to="/blogs" onClick={closeMobileMenu}>Blogs</Link></li>
                <li><Link to="/contact" onClick={closeMobileMenu}>Contact</Link></li>
              </ul>
            </nav>
          </div>
        </div>
      </div>


      {/* Backdrop */}
      <div className="menu-backdrop"></div>
    </>
  );
}

export default HeaderOne;